export default __webpack_public_path__ + "static/media/arrow_dropdown.11cc6eec.svg";